import Home from "./Home.vue";
import Privacy from "./Privacy.vue";
import Terms from "./Terms.vue";

export const routes = [
    { path: "/", component: Home },
    { path: "/privacy", component: Privacy },
    { path: "/terms", component: Terms },
    {
        path: "/:pathMatch(.*)*",
        component: Home,
    },
];
